import { Suspense } from "react";
import { LogLevel } from "@azure/msal-browser";
import { configureAuth, HealthApp } from "@fdoh/health-ui-react";
import { PublicClientApplication } from '@azure/msal-browser';
import { LoadingComponent } from "./components";
import { getConfig } from "./Config";
import { msalConfig } from "./AuthConfig";
import Menu from "./Menu";
import routes from "./Routes";
import UserMenu from "./UserMenu";
import "@tabler/core/dist/css/tabler.css";
import "react-toastify/dist/ReactToastify.css";
import "../scss/default.scss";
import "../css/sizing.css";
import "../css/custom.css";
import "../css/toasts.css";
import "../scss/default.scss";

declare global {
  interface Document {
    documentMode?: any;
  }
}

const configuration = getConfig();
const msalInstance = new PublicClientApplication(msalConfig);
/*const msalInstance = configureAuth(configuration, LogLevel.Error);*/

const PrivateInspectionApp = () => {
  return (
    <Suspense fallback={<div>Loading... </div>}>
      <HealthApp
        config={configuration}
        menu={<Menu />}
        msalInstance={msalInstance}
        routes={routes}
        userMenu={<UserMenu />}
      />
      <LoadingComponent></LoadingComponent>
    </Suspense>
  );
};

export default PrivateInspectionApp;
